// extracted by mini-css-extract-plugin
export default {"card":"Question_card__xNuya","utterance":"Question_utterance__uUx2c"};